import * as types from '../actiontypes';
import {promiseAreas} from '../../util/uiconstants';
import {API_RESOURCES, createApiReadAction} from '../../util/api';

export function getAllTasks(url, quickFilterId) {
	return {
		type: types.GET_ALL_TASKS,
		meta: {
			api: {
				url: url,
				method: 'GET',
				//data: { resource: resource },
				trackWithArea: promiseAreas.TASK_LIST_AREA
			}
		},
		quickFilterId: quickFilterId
	};
}

export function getAllTasksToRelate(engagementId, filters) {
	return createApiReadAction(
		types.GET_ALL_RESPONSIVE_TASKS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TASKS]: undefined
		},
		filters,
		{resolve: true},
		true
	);
}

export function getAllBuildTasks(url) {
	return {
		type: types.GET_ALL_BUILD_TASKS,
		meta: {
			api: {
				url: url,
				method: 'GET',
				trackWithArea: promiseAreas.BUILD_TASK_LIST
			}
		}
	};
}

export function getAllTasksCount(url, resource) {
	return {
		type: types.GET_ALL_TASKS_COUNT,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: {resource: resource},
				trackWithArea: promiseAreas.TASK_LIST_AREA
			}
		}
	};
}

export function getAllTasksForWCGW(url, resource) {
	return {
		type: types.GET_ALL_TASKS_FOR_WCGW,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: {resource: resource}
			}
		}
	};
}

export function getAllResponsiveTask(url) {
	return {
		type: types.GET_ALL_RESPONSIVE_TASKS,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		},
		resolve: true
	};
}

export function updateTimePhase(dueDate, updatedTasks) {
	return {
		type: types.UPDATE_DUE_DATE,
		payload: {dueDate: dueDate, tasks: updatedTasks}
	};
}

export const updateAllTasksStore = () => {
	return {type: types.GET_ALL_TASKS, response: []};
};

export const getAllTasksByCriteria = (engagementId, filters) => {
	return createApiReadAction(
		types.GET_ALL_TASKS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TASKS]: undefined
		},
		filters,
		{resolve: true}
	);
};

export const getAllTasksOverview = (engagementId, filters, actionProps) => {
	return createApiReadAction(
		types.GET_ALL_TASKS_OVERVIEW,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TASKOVERVIEW]: undefined
		},
		filters,
		{...actionProps, resolve: true},
		undefined,
		promiseAreas.FIT_BREADCRUMB
	);
};
